export const PaycheckType = {
    Paycheck: 1,
    AnnualStatements: 2
};
